import { useContextAppointment } from "@/modules/patients/hooks/useContextAppointment"

const useHealthInformationInContextAppointment = () => {
  const contextAppointment = useContextAppointment()
  const isAdministrativeCall = contextAppointment?.service === "ADMINISTRATIVE_REQUEST"
  const isFollowUp = contextAppointment?.appointmentType === "FOLLOW_UP"

  return contextAppointment !== null && !isAdministrativeCall && !isFollowUp
}

export { useHealthInformationInContextAppointment }
